import React, { useEffect, useState } from "react";
import { FaIdCard } from "react-icons/fa";
import { FiEdit2, FiInfo, FiTrash2 } from "react-icons/fi";
import { FaArrowLeft } from "react-icons/fa6";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdFileDownload } from "react-icons/md";
import { MdOutlineNoteAlt } from "react-icons/md";
import { BiSolidBank } from "react-icons/bi";
import { FiUserCheck } from "react-icons/fi";
import { RiBuilding3Fill } from "react-icons/ri";
import { FaMoneyCheck } from "react-icons/fa6";
import { MdOutlineEmojiTransportation } from "react-icons/md";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  MenuItem,
  ListItemIcon,
  Menu,
} from "@mui/material";
import { FaCalendarAlt, FaDollarSign, FaPhoneAlt } from "react-icons/fa";
import { formatToIndianNumber, toInitials } from "../../../utilities";
import { Spinner } from "react-bootstrap";
import { format } from "date-fns";
import { toast } from "react-toastify";
import {
  deleteDoorStepEmployeeApi,
  getDoorStepEmployeeDetailsApi,
} from "../../../services/DoorStepEmployeeService";
import AddDoorStepEmployeeModal from "../AddDoorStepEmployeeModal";

export default function DoorStepEmployeeDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const handleToggleEditModal = () => {
    setEditModal(!editModal);
  };
  const handleToggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const tabs = [
    {
      name: "Attendance Details",
      icons: <FaCalendarAlt className="me-1" />,
      path: `/door-step-employee/${id}`,
    },
    {
      name: "Salary Details",
      icons: <FaDollarSign className="me-1" />,
      path: `/door-step-employee/${id}/salary`,
    },
  ];

  const getEmployee = () => {
    setLoading(true);
    getDoorStepEmployeeDetailsApi(id)
      .then((res) => {
        setError("");
        setData(res?.data?.results || null);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getEmployee();
  }, []);

  const handleAfterEmployeeEdit = () => {
    handleToggleEditModal();
    getEmployee();
  };

  const deleteEmployee = () => {
    setDeleteLoading(true);
    deleteDoorStepEmployeeApi(data?.id || "")
      .then((res) => {
        toast.success("Delete Successfully");
        handleToggleDeleteModal();
        navigate("/door-step-employee");
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };
  if (loading) {
    return (
      <div className="text-center mt-3">
        <Spinner animation="border" />
      </div>
    );
  }
  if (error) {
    return <div className="mt-2 alert alert-danger">{error}</div>;
  }
  return (
    <div className="card overflow-hidden">
      <div className="container-fluid p-0">
        <div className="row">
          <div className="col-md-4 ps-4 pe-4 pe-md-2 py-2">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Link
                to="/door-step-employee"
                className="btn btn-outline-light rounded-circle border-0"
                title="Back"
                style={{ padding: "0.5rem" }}
              >
                <FaArrowLeft className="text-dark fs-5" />
              </Link>

              {/* Action Menu */}
              <button
                title="More actions"
                onClick={handleMenuOpen}
                className="btn btn-outline-light rounded-circle border-0"
                style={{ padding: "0.4rem" }}
              >
                <BsThreeDotsVertical className="text-dark fs-5" />
              </button>
            </div>
            <div className="d-flex flex-column align-items-center">
              <div
                className="rounded-circle bg-light text-dark d-flex justify-content-center align-items-center overflow-hidden"
                style={{
                  width: "70px",
                  height: "70px",
                  fontWeight: 500,
                  fontSize: "1.75rem",
                }}
              >
                <span>{toInitials(data?.name || "")}</span>
              </div>
              <h4 className="mt-3 text-primary">{data?.name || ""}</h4>
            </div>
            <div className="px-2 mt-4">
              <div className="d-flex align-items-start gap-2 mb-2">
                <FaPhoneAlt className="text-dark" size="15" />
                <small className="fw-medium text-dark">Phone </small>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.95rem" }}
                >
                  {": "}
                  {data?.mobile_number || "-"}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <FiUserCheck className="text-dark" size="15" />
                <small className="fw-medium text-dark">Designation </small>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {": "}
                  {data?.designation || "-"}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <RiBuilding3Fill className="text-dark" size="15" />
                <small className="fw-medium text-dark">Apartment Type</small>
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  {": "}
                  {data?.apartment_type || "-"}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <FaIdCard className="text-dark" size="15" />
                <small className="fw-medium text-dark">PAN</small>
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  {": "}
                  {data?.pan_no || "-"}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <BiSolidBank className="text-dark" size="15" />
                <small className="fw-medium text-dark">Bank</small>
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  {": "}
                  {data?.bank_name || "-"}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <FaMoneyCheck className="text-dark" size="15" />
                <small className="fw-medium text-dark">IFSC</small>
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  {": "}
                  {data?.bank_ifsc || "-"}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <MdOutlineNoteAlt className="text-dark" size="15" />
                <small className="fw-medium text-dark">Account No</small>
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  {": "}
                  {data?.bank_account_number || "-"}
                </span>
              </div>
              <div className="d-flex align-items-center gap-2 mb-2">
                <MdOutlineEmojiTransportation className="text-dark" size="15" />
                <small className="fw-medium text-dark">Fuel Allowance </small>
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  {": "}₹{formatToIndianNumber(data?.fuel_allowance)}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2">
                <FaCalendarAlt className="text-dark" size="15" />
                <small className="fw-medium text-dark">Joining Date </small>
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  {": "}
                  {data?.created_at
                    ? format(data?.created_at, "dd MMM yyyy")
                    : "-"}
                </span>
              </div>
              <hr className="my-3" />
              <div className="d-flex justify-content-between mb-2">
                <span className="fw-medium">Adhaar Image</span>
                <a
                  href={`${process.env.REACT_APP_BASE_URL}${data?.adhar_image}`}
                  download={
                    data?.adhar_image?.split("/").pop() || "aadhar_image"
                  }
                  className="p-1 btn btn-outline-light"
                  title="Download adhaar"
                  // target="_blank"
                  // rel="noopener noreferrer"
                >
                  <MdFileDownload className="text-dark" />
                </a>
              </div>
              <div
                className="border border-light rounded-3 shadow-sm overflow-hidden"
                style={{ height: "175px" }}
              >
                {data?.adhar_image ? (
                  <img
                    src={
                      data?.adhar_image
                        ? `${process.env.REACT_APP_BASE_URL}${data.adhar_image}`
                        : null
                    }
                    alt="Adhar Preview"
                    style={{
                      objectFit: "contain",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                ) : (
                  <div
                    className="bg-lighter  fw-medium d-flex justify-content-center align-items-center"
                    style={{ height: "100%", width: "100%" }}
                  >
                    No adhaar found
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-8 border-start p-0">
            <div className="border-bottom p-2 px-4 px-md-2">
              <ul className="custom-nav1 nav nav-pills">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.path}>
                    <NavLink
                      to={tab.path}
                      end={true}
                      className={({ isActive }) =>
                        "nav-link rounded-pill" + (isActive ? " active" : "")
                      }
                    >
                      {tab.icons}
                      {tab.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: "8px",
            padding: "0.15rem 0",
            minWidth: "130px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          },
        }}
      >
        <MenuItem
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
          onClick={() => {
            handleMenuClose();
            handleToggleEditModal();
          }}
        >
          <ListItemIcon>
            <FiEdit2 size={14} />
          </ListItemIcon>
          Edit
        </MenuItem>
        <MenuItem
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
          onClick={() => {
            handleMenuClose();
            handleToggleDeleteModal();
          }}
        >
          <ListItemIcon>
            <FiTrash2 size={14} color="red" />
          </ListItemIcon>
          Delete
        </MenuItem>
      </Menu>

      <AddDoorStepEmployeeModal
        data={data}
        visible={editModal}
        onClose={handleToggleEditModal}
        onAfterSubmit={handleAfterEmployeeEdit}
      />

      <Dialog
        maxWidth="xs"
        fullWidth
        open={deleteModal}
        onClose={handleToggleDeleteModal}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>{data?.name}</strong>? This
              action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleDeleteModal}
            color="inherit"
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={deleteEmployee}>
            {deleteLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
